import dynamic from 'next/dynamic'

// Footer is below the fold on every landing page. Loading it as a dynamic
// chunk keeps its ~14 kB of JS + data off the initial parse path while still
// rendering server-side (ssr default = true) for SEO link equity.
const Footer = dynamic(() => import('./FooterImpl'))

export default Footer
